export interface RplQuestion {
  key: string;
  label: string;
  questionText: string;
  requiresFile?: boolean;
  fileKey?: string;
}

export const RPL_QUESTIONS: Record<string, RplQuestion> = {
  question1_1: {
    key: 'question1_1',
    label: 'Question 1.1',
    questionText:
      'I understand that the process of attaining dedicated status with Natshoot (NHSA) is a legally prescribed process and that it entails strict legally prescribed actions to which both the NHSA and myself have to adhere to with no exceptions, as it has direct bearing on my continued legal possession of firearms.',
  },
  question2_1: {
    key: 'question2_1',
    label: 'Question 2.1',
    questionText:
      'I regularly, and in a dedicated manner, participate in Hunting and related activities with my Hunting firearms.',
  },
  question2_2: {
    key: 'question2_2',
    label: 'Question 2.2',
    questionText:
      'I regularly, and in a dedicated manner, participate in Sport Shooting and related activities with my Sport Shooting firearms.',
  },
  question3_1: {
    key: 'question3_1',
    label: 'Question 3.1',
    questionText:
      'I was awarded Bona Fide Hunter Status by SAPS under the 1969 Act and apply to be awarded Dedicated Hunter status with Natshoot (NHSA) based on RPL.',
    requiresFile: true,
    fileKey: 'questionFile3_1Id',
  },
  question3_2: {
    key: 'question3_2',
    label: 'Question 3.2',
    questionText:
      'I was awarded Bona Fide Sport-Person Status by SAPS under the 1969 Act and apply to be awarded Dedicated Sport-Person status with Natshoot (NHSA) based on RPL.',
    requiresFile: true,
    fileKey: 'questionFile3_2Id',
  },
  question3_3: {
    key: 'question3_3',
    label: 'Question 3.3',
    questionText:
      "I completed a Professional Hunter's course and apply to be awarded Dedicated Hunter status with Natshoot (NHSA) based on RPL.",
    requiresFile: true,
    fileKey: 'questionFile3_3Id',
  },
  question3_4: {
    key: 'question3_4',
    label: 'Question 3.4',
    questionText:
      'I completed the CHASA Proficiency Award Test and apply to be awarded Dedicated Hunter status with Natshoot (NHSA) based on RPL.',
    requiresFile: true,
    fileKey: 'questionFile3_4Id',
  },
  question3_5: {
    key: 'question3_5',
    label: 'Question 3.5',
    questionText:
      'I hold current and up to date Dedicated Hunter Status with another accredited Hunting Association and apply to be awarded Dedicated Hunter status with Natshoot (NHSA) based on RPL.',
    requiresFile: true,
    fileKey: 'questionFile3_5Id',
  },
  question3_6: {
    key: 'question3_6',
    label: 'Question 3.6',
    questionText:
      'I hold current and up to date Dedicated Sport Person Status with another accredited Sport Shooting Association and apply to be awarded Dedicated Sport-Person status with Natshoot (NHSA) based on RPL.',
    requiresFile: true,
    fileKey: 'questionFile3_6Id',
  },
  question3_7: {
    key: 'question3_7',
    label: 'Question 3.7',
    questionText:
      'I have completed the Hunters Training Course in an European Country or in any State in the USA, and apply to be awarded Dedicated Hunter status with Natshoot (NHSA) based on RPL.',
    requiresFile: true,
    fileKey: 'questionFile3_7Id',
  },
  question4_1: {
    key: 'question4_1',
    label: 'Question 4.1',
    questionText:
      'I know and understand that in terms of the FCA (Act 60 of 2000) and its Regulations (2004), I may not conduct any PH related work with the firearms I have licenced based on my Dedicated Hunter Status with Natshoot (NHSA).',
  },
  question4_2: {
    key: 'question4_2',
    label: 'Question 4.2',
    questionText:
      'I understand that Dedicated Hunter Status with Natshoot (NHSA) does not include any activity which would entitle me to apply for a NHSA endorsement for a licence application for a semi-automatic rifle/carbine, which is typically used for Sports-Shooting, despite the fact that I may use a legally licenced semi-automatic firearm to participate in NHSA postal target shooting events & competitions.',
  },
  question4_3: {
    key: 'question4_3',
    label: 'Question 4.3',
    questionText:
      'I understand that it is entirely my own responsibility to annually conduct the necessary activities as accepted by Natshoot (NHSA) to maintain my Dedicated Hunter and/or Sport-Person Status with NHSA.',
  },
  question4_4: {
    key: 'question4_4',
    label: 'Question 4.4',
    questionText:
      'I understand that if I do not submit my annual Dedicated Hunter and or Sport Shooting report to Natshoot (NHSA) on or before the last day of my birthday month annually, that the NHSA has to inform the SAPS (CFR) of the fact that I have not submitted an annual report and that I would then have forfeited my Dedicated Hunter and/or Sport-Person status with the NHSA due to my own actions or lack thereof. I also understand that it then remains my responsibility to complete the necessary SAPS 521(c) (Change of Circumstances Form) and to submit it to my DFO, after having been informed of the lapse of my dedicated status with NHSA.',
  },
  question4_5: {
    key: 'question4_5',
    label: 'Question 4.5',
    questionText:
      'I understand that I may submit a non-active report for a specific year (with reasons) and that my Dedicated Hunter and/or Sport-Person status will not be in jeopardy because of that, but that I must furnish good reasons why I for a second consecutive year return a non-active report.',
  },
  question4_6: {
    key: 'question4_6',
    label: 'Question 4.6',
    questionText:
      "I understand that the maintenance of my dedicated status with Natshoot (NHSA) is entirely my own responsibility, and that I have no claim against the NHSA, any of it's affiliates or associates or any of it's personnel or officers whatsoever, should I loose my dedicated status because of non-compliance with any of the above by Law prescribed processes due to my actions or the lack thereof.",
  },
};

export const RPL_QUESTION_KEYS = {
  GENERAL: ['question1_1'],
  HUNTER_SPECIFIC: ['question2_1', 'question4_1', 'question4_2'],
  SPORTS_SPECIFIC: ['question2_2'],
  RPL_BASIS: [
    'question3_1',
    'question3_2',
    'question3_3',
    'question3_4',
    'question3_5',
    'question3_6',
    'question3_7',
  ],
  RESPONSIBILITIES: [
    'question4_3',
    'question4_4',
    'question4_5',
    'question4_6',
  ],
} as const;